var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c(
        "el-header",
        [
          _c("el-input", {
            attrs: {
              type: "text",
              placeholder: "请输入关键词搜索",
              clearable: "",
            },
            on: { clear: _vm.cancelSearch },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.doSearch($event)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "append",
                fn: function () {
                  return [
                    _c(
                      "el-button",
                      { on: { click: _vm.doSearch } },
                      [_c("el-icon", [_c("Search")], 1)],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.queryText,
              callback: function ($$v) {
                _vm.queryText = $$v
              },
              expression: "queryText",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-main",
        [
          _c("SimpleTable", {
            attrs: {
              columns: _vm.columns,
              data: _vm.tableData,
              pagination: _vm.page,
              "show-check-box": false,
              height: _vm.tableHeight,
              "show-operation-column": true,
              "table-size": "small",
              "table-width": "100% !important",
            },
            on: {
              handleSizeChange: _vm.handleSizeChange,
              handleCurrentChange: _vm.handleCurrentChange,
            },
            scopedSlots: _vm._u([
              {
                key: "table_operation",
                fn: function (ref) {
                  var scope = ref.scope
                  return [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.selectRecord(scope.row)
                          },
                        },
                      },
                      [
                        _c("el-icon", [_c("Check")], 1),
                        _vm._v("\n          选择\n        "),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }